// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client'; // Corrected import path
import './assets/styles/global.css'
import App from './components/App';


const root = createRoot(document.getElementById('root'));
root.render(<App />);